<template>
    <a @click.prevent="submit" :href="url" target="_blank">
        <slot></slot>
    </a>
</template>

<script>
import FormMixin from '@/mixins/FormMixin';
import ItemDownloadService from '@/services/item-download.service.js';

export default {
    props: {
        url: {
            type: String,
            required: true
        },
        csrf: {
            type: String
        }
    },
    mixins: [
        FormMixin
    ],
    methods: {
        async submit() {
            try {
                await ItemDownloadService.store({path: this.url});
            } catch (error) {

            } finally {
                window.open(this.url, '_blank');
            }
        }
    }
}
</script>
